import React, { useState } from "react";
// 1. Import Toast Components
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const generateBatches = () => {
  const years = [];
  for (let i = 2025; i >= 1981; i--) {
    years.push(`${i}-${i + 3}`);
  }
  years.push("Not Applicable");
  return years;
};
const batchOptions = generateBatches();

const OnlineGrievance = () => {
  const [formData, setFormData] = useState({
    email: "",
    name: "",
    identity: "",
    idNumber: "",
    branch: "",
    year: "",
    batch: "",
    phone: "",
    category: "",
    description: "",
  });

  const GOOGLE_FORM_ACTION_URL =
    "https://docs.google.com/forms/d/e/1FAIpQLScRjQx9jjvyXhbxPimbDJmo9UyiQe37CRHkKnAdRUMqCNEQqA/formResponse";

  const ENTRY_IDS = {
    email: "entry.90955483",
    name: "entry.867472233",
    identity: "entry.638084362",
    idNumber: "entry.1952397065",
    branch: "entry.725466645",
    year: "entry.703966156",
    batch: "entry.200427540",
    phone: "entry.407133512",
    category: "entry.1015939212",
    description: "entry.639316586",
  };

  const handleChange = (e, field) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Create a loading toast
    const id = toast.loading("Submitting your grievance...");

    const formUrl = new URLSearchParams();
    const dataToPost = [
      [ENTRY_IDS.email, formData.email],
      [ENTRY_IDS.name, formData.name],
      [ENTRY_IDS.identity, formData.identity],
      [ENTRY_IDS.idNumber, formData.idNumber],
      [ENTRY_IDS.branch, formData.branch],
      [ENTRY_IDS.year, formData.year],
      [ENTRY_IDS.batch, formData.batch],
      [ENTRY_IDS.phone, formData.phone],
      [ENTRY_IDS.category, formData.category],
      [ENTRY_IDS.description, formData.description],
    ];

    dataToPost.forEach(([id, value]) => formUrl.append(id, value));

    fetch(GOOGLE_FORM_ACTION_URL, {
      method: "POST",
      mode: "no-cors",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: formUrl.toString(),
    })
      .then(() => {
        // 2. SUCCESS TOAST
        toast.update(id, {
          render: "Grievance submitted successfully!",
          type: "success",
          isLoading: false,
          autoClose: 5000,
        });

        setFormData({
          email: "",
          name: "",
          identity: "",
          idNumber: "",
          branch: "",
          year: "",
          batch: "",
          phone: "",
          category: "",
          description: "",
        });
      })
      .catch((err) => {
        // 3. ERROR TOAST
        toast.update(id, {
          render: "Error submitting form. Please try again.",
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });
      });
  };

  const objectives = [
    "To provide a platform to resolve grievances of students, staff and other stakeholders",
    "To formulate the policy to investigate and review complaints or grievances of students and faculties",
    "To create awareness of the availability of members for students and faculties to report grievances",
    "To investigate the cause of grievances to ensure the effectual solution",
    "To ensure corrective measures for the grievances",
    "To find the cause of dissatisfaction to create a healthy environment",
  ];

  const grievanceCategories = [
    "Academic",
    "Non-Academic",
    "Placement",
    "Assesment",
    "Attendance",
    "College Fees",
    "Abuse by Student / Faculty",
    "Examination",
    "Boys Hostel",
    "Girls Hostel",
    "Others",
  ];

  const committeeMembers = [
    {
      name: "Sri J. Siva Kumar",
      designation: "Principal",
      role: "Chairperson",
    },
    {
      name: "K. Venkateswara Rao",
      designation: "HOD/CIV, GPT, Vijayawada",
      role: "Member",
    },
    {
      name: "P.G.N.V. Subrahmanyam",
      designation: "SL/CME, GPT, Gannavaram",
      role: "Member",
    },
    { name: "D. Rajesh", designation: "HOD/CCB", role: "Member" },
  ];

  return (
    <div className="bg-[#f0f2f5] min-h-screen py-10 px-4 md:px-20 font-sans text-gray-800">
      {/* 4. TOAST CONTAINER (Essential to show the toasts) */}
      <ToastContainer position="top-right" theme="colored" />

      <div className="max-w-5xl mx-auto mb-8 bg-white p-8 rounded-lg shadow-sm border border-gray-200">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">
          Student Grievance Redressal Committee
        </h1>
        <h2 className="text-xl font-semibold mb-4 text-gray-700">
          Objectives of the Committee
        </h2>
        <ul className="list-disc ml-6 space-y-2 text-gray-600">
          {objectives.map((obj, i) => (
            <li key={i}>{obj}</li>
          ))}
        </ul>
      </div>

      <form onSubmit={handleSubmit} className="max-w-5xl mx-auto space-y-4">
        <div className="bg-white rounded-t-lg border-t-[10px] border-red-600 shadow-sm p-6 border-x border-b border-gray-200">
          <h2 className="text-3xl font-normal mb-2">
            Online Grievance Redressal Tool
          </h2>
          <p className="text-sm text-red-600">* Indicates required question</p>
        </div>

        <FormCard label="Email" required>
          <input
            type="email"
            required
            value={formData.email}
            onChange={(e) => handleChange(e, "email")}
            placeholder="Your email"
            className="w-full border-b border-gray-300 focus:border-red-600 focus:border-b-2 outline-none py-3 mt-4 transition-all"
          />
        </FormCard>

        <FormCard label="Enter Your Name" required>
          <input
            type="text"
            required
            value={formData.name}
            onChange={(e) => handleChange(e, "name")}
            placeholder="Your answer"
            className="w-full border-b border-gray-300 focus:border-red-600 focus:border-b-2 outline-none py-3 mt-4 transition-all"
          />
        </FormCard>

        <FormCard label="I am a..." required>
          <select
            required
            value={formData.identity}
            onChange={(e) => handleChange(e, "identity")}
            className="w-full md:w-1/2 border border-gray-300 rounded p-3 mt-4 bg-white outline-none cursor-pointer"
          >
            <option value="">Choose</option>
            <option value="Student of this Polytechnic">
              Student of this Polytechnic
            </option>
            <option value="Teaching Faculty">Teaching Faculty</option>
            <option value="Non Teaching Faculty">Non Teaching Faculty</option>
            <option value="Parent">Parent</option>
            <option value="Others">Others</option>
          </select>
        </FormCard>

        <FormCard
          label="Your PIN Number/Faculty ID/if Parent (Ward PIN)"
          required
        >
          <input
            type="text"
            required
            value={formData.idNumber}
            onChange={(e) => handleChange(e, "idNumber")}
            placeholder="Your answer"
            className="w-full border-b border-gray-300 focus:border-red-600 focus:border-b-2 outline-none py-3 mt-4 transition-all"
          />
        </FormCard>

        <FormCard label="Branch" required>
          <select
            required
            value={formData.branch}
            onChange={(e) => handleChange(e, "branch")}
            className="w-full md:w-2/3 border border-gray-300 rounded p-3 mt-4 bg-white outline-none"
          >
            <option value="">Choose</option>
            <option value="Artificial Intelligence and Machine Learning">
              Artificial Intelligence and Machine Learning
            </option>
            <option value="Civil Engineering">Civil Engineering</option>
            <option value="Computer Science & Engineering">Computer Science & Engineering</option>
            <option value="Cloud Computing & Big Data">
              Cloud Computing & Big Data
            </option>
            <option value="Electronics & Communication Engineering">
              Electronics & Communication Engineering
            </option>
            <option value="Electrical & Electronics Engineering">
              Electrical & Electronics Engineering
            </option>
            <option value="Mechanical Engineering">
              Mechanical Engineering
            </option>
            
          </select>
        </FormCard>

        <FormCard label="Year of Study" required>
          <select
            required
            value={formData.year}
            onChange={(e) => handleChange(e, "year")}
            className="w-full md:w-1/3 border border-gray-300 rounded p-3 mt-4 bg-white outline-none"
          >
            <option value="">Choose</option>
            <option value="1st Year">1st Year</option>
            <option value="2nd Year">2nd Year</option>
            <option value="3rd Year">3rd Year</option>
            <option value="Course Completed">Course Completed</option>
          </select>
        </FormCard>

        <FormCard label="Batch" required>
          <select
            required
            value={formData.batch}
            onChange={(e) => handleChange(e, "batch")}
            className="w-full md:w-1/3 border border-gray-300 rounded p-3 mt-4 bg-white outline-none"
          >
            <option value="">Choose</option>
            {batchOptions.map((batch) => (
              <option key={batch} value={batch}>
                {batch}
              </option>
            ))}
          </select>
        </FormCard>

        <FormCard label="Contact Number" required>
          <input
            type="text"
            required
            value={formData.phone}
            onChange={(e) => handleChange(e, "phone")}
            placeholder="Your answer"
            className="w-full border-b border-gray-300 focus:border-red-600 focus:border-b-2 outline-none py-3 mt-4 transition-all"
          />
        </FormCard>

        <FormCard label="Is your Grievance about?" required>
          <select
            required
            value={formData.category}
            onChange={(e) => handleChange(e, "category")}
            className="w-full md:w-1/2 border border-gray-300 rounded p-3 mt-4 bg-white outline-none"
          >
            <option value="">Choose</option>
            {grievanceCategories.map((cat, i) => (
              <option key={i} value={cat}>
                {cat}
              </option>
            ))}
          </select>
        </FormCard>

        <FormCard label="Describe about the Grievance?" required>
          <textarea
            required
            value={formData.description}
            onChange={(e) => handleChange(e, "description")}
            placeholder="Your answer"
            className="w-full border-b border-gray-300 focus:border-red-600 focus:border-b-2 outline-none py-3 mt-4 min-h-[100px]"
          ></textarea>
        </FormCard>

        <div className="flex justify-between items-center py-6">
          <button
            type="submit"
            className="bg-red-600 text-white font-bold py-3 px-10 rounded shadow hover:bg-red-700 transition active:scale-95"
          >
            Submit
          </button>
          <button
            type="button"
            onClick={() =>
              setFormData({
                email: "",
                name: "",
                identity: "",
                idNumber: "",
                branch: "",
                year: "",
                batch: "",
                phone: "",
                category: "",
                description: "",
              })
            }
            className="text-red-600 font-semibold hover:bg-red-50 py-2 px-4 rounded transition"
          >
            Clear form
          </button>
        </div>
      </form>

      <div className="max-w-5xl mx-auto mt-20 p-8 bg-white rounded-lg shadow-sm border border-gray-200">
        <h2 className="text-2xl font-bold mb-4 uppercase text-gray-800">
          Establishment of Online Grievance Redressal Mechanism
        </h2>
        <div className="overflow-x-auto border border-gray-200 rounded-lg">
          <table className="w-full text-left">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-6 py-4 font-bold text-gray-700 w-20">
                  Sl.no
                </th>
                <th className="px-6 py-4 font-bold text-gray-700">
                  Name & Designation of the Person
                </th>
                <th className="px-6 py-4 font-bold text-gray-700 text-center">
                  Designation in Committee
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {committeeMembers.map((member, index) => (
                <tr key={index}>
                  <td className="px-6 py-8 align-top text-gray-900 font-medium">
                    {index + 1}
                  </td>
                  <td className="px-6 py-8">
                    <div className="font-bold text-gray-900 uppercase tracking-tight">
                      {member.name},
                    </div>
                    <div className="text-gray-700 mt-1">
                      {member.designation}
                    </div>
                  </td>
                  <td className="px-6 py-8 text-center font-bold text-gray-900 uppercase">
                    {member.role}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const FormCard = ({ label, required, children }) => (
  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 transition-colors">
    <label className="text-base font-medium block text-gray-900">
      {label} {required && <span className="text-red-600">*</span>}
    </label>
    {children}
  </div>
);

export default OnlineGrievance;
